import type { LucideIcon } from "lucide-react";
import { Car, Bike, List, FileText } from "lucide-react";
import { getLanguage } from "@/utils/languageUtils";
import { commonTitleLabels } from "@/i18n";

export type LeadboxNavLink = {
  title: string;
  url: string;
  icon: LucideIcon;
};

export type LeadboxNavOptions = {
  /** "Bud och auktionslista" — when false, Leadbox Annonser is hidden entirely. */
  canViewBidsOverview?: boolean;
};

/** Primary + tools + footer links for Leadbox sidebar and mobile strip (single source of truth). */
export function getLeadboxNavSections(options: LeadboxNavOptions = {}): {
  primary: LeadboxNavLink[];
  tools: LeadboxNavLink[];
  footer: LeadboxNavLink[];
} {
  const titles = commonTitleLabels(getLanguage());
  const tools: LeadboxNavLink[] = [
    {
      title: titles.vehicleCards,
      icon: FileText,
      url: "/admin/leadbox/vehicle-cards",
    },
  ];
  if (options.canViewBidsOverview === true) {
    tools.push({
      title: titles.leadboxListings,
      icon: List,
      url: "/admin/leadbox/listings",
    });
  }
  return {
    primary: [
      { title: titles.carLeadbox, icon: Car, url: "/admin/leadbox" },
      { title: titles.motorcycleLeadbox, icon: Bike, url: "/admin/leads/mc" },
    ],
    tools,
    footer: [],
  };
}

export function flattenLeadboxNavForStrip(sections: ReturnType<typeof getLeadboxNavSections>): LeadboxNavLink[] {
  return [...sections.primary, ...sections.tools];
}

/** Active state for top-level Leadbox nav (detail pages may not match a single tab). */
export function isLeadboxNavLinkActive(url: string, pathname: string): boolean {
  if (url === "/admin/leadbox") {
    return pathname === "/admin/leadbox";
  }
  if (url === "/admin/leads/mc") {
    return pathname === "/admin/leads/mc";
  }
  return pathname === url || pathname.startsWith(`${url}/`);
}
